import { render, staticRenderFns } from "./color-panel.vue?vue&type=template&id=ebe9e2e0"
import script from "./color-panel.vue?vue&type=script&lang=ts"
export * from "./color-panel.vue?vue&type=script&lang=ts"
import style0 from "./color-panel.vue?vue&type=style&index=0&id=ebe9e2e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports